<div
  style="width: 100%; height: 100%"
  [style]="{
    borderImageSource: 'url(' + src() + ')',
    borderImageSlice: 100 * y()[0] + '% ' + 100 * (1 - x()[1]) + '% ' + 100 * (1 - y()[1]) + '% ' + 100 * x()[0] + '% fill',
    borderImageWidth: width(),
  }"
></div>
